import { Mutex } from 'async-mutex'
import { GetUserJwt, reqGetUserJwt } from '@weblite/ts-action/auth'
import { contentJwtStorage, userJwtStorage } from '$logic/auth/storage'
import { request } from '$setup/ws'
import { isExpiredJwt } from '$func/jwt'

const getClientUserIdentityTokenMutex = new Mutex()
export async function getClientUserIdentityToken(contentUri?: string) {
  return getClientUserIdentityTokenMutex.runExclusive(async () => {
    const cachedToken = contentUri
      ? contentJwtStorage.get()?.[contentUri]
      : userJwtStorage.get()?.token

    if (cachedToken && !isExpiredJwt(cachedToken)) return cachedToken

    const res = await request<GetUserJwt>(reqGetUserJwt({ contentUri }), {
      retry: -1,
    })

    if (res.error) return null

    if (contentUri)
      contentJwtStorage.set({
        ...contentJwtStorage.get(),
        [contentUri]: res.payload.jwt,
      })
    else userJwtStorage.set({ token: res.payload.jwt })
    return res.payload.jwt
  })
}
